export default () => ({
    isLoading: false,
    abortController: null,
    pagination: {},
    activeFilters: {},
    filters: {},

    init() {
        this.syncData(this.$refs.results)

        this.$refs.form.addEventListener('change', (event) => {
            event?.preventDefault()
            this.updateResults()
        })

        this.$refs.form.addEventListener('submit', (event) => {
            event?.preventDefault()
            this.updateResults()
        })

        this.$refs.form.addEventListener('changeDate', (event) => {
            const { start, end } = event.detail

            this.activeFilters.start = start
            this.activeFilters.end = end

            this.$nextTick(() => this.updateResults())
        })
    },

    syncData(el) {
        this.pagination = JSON.parse(el.dataset.pagination)
        this.activeFilters = JSON.parse(el.dataset.activeFilters)
        this.filters = JSON.parse(el.dataset.filters)
    },

    replaceRef(name, page = 1) {
        const singleInputs = ['start', 'end']
        const privateUrl = new URL(
            window.location.pathname,
            window.location.origin
        )
        const publicUrl = new URL(
            window.location.pathname,
            window.location.origin
        )
        const formData = new FormData(this.$refs.form)

        privateUrl.searchParams.set('sida', page)

        Array.from(formData.entries()).forEach(([key, value]) => {
            if (value) {
                if (singleInputs.includes(key)) {
                    privateUrl.searchParams.set(key, value)
                    publicUrl.searchParams.set(key, value)
                } else {
                    privateUrl.searchParams.append(`${key}[]`, value)
                    publicUrl.searchParams.append(`${key}[]`, value)
                }
            }
        })

        this.abortController?.abort()

        this.abortController = new AbortController()

        return fetch(privateUrl, { signal: this.abortController.signal })
            .then((response) => response.text())
            .then((html) => {
                const parser = new DOMParser()
                const doc = parser.parseFromString(html, 'text/html')
                const results = doc.querySelector(`[x-ref="${name}"]`)

                if (results) {
                    this.$refs[name].innerHTML = results.innerHTML

                    this.syncData(results)
                }

                window.history.replaceState({}, '', publicUrl)
            })
            .catch((error) => {
                if (error.name !== 'AbortError') {
                    console.error(error)
                }
            })
            .finally(() => {
                this.abortController = null
            })
    },

    updateResults(page) {
        this.isLoading = true

        this.replaceRef('results', page).finally(() => {
            this.isLoading = false
        })
    },

    hasActiveFilters(keys = []) {
        return keys.some((key) => {
            const value = this.activeFilters[key]

            return Array.isArray(value) ? value.length > 0 : Boolean(value)
        })
    },

    labelsForActiveFilters(keys = []) {
        const labels = []

        keys.forEach((key) => {
            const values = this.activeFilters[key]

            if (Array.isArray(values)) {
                values?.forEach((value) => {
                    const label = this.filters[key][value]?.label

                    if (label) {
                        labels.push(label)
                    }
                })
            } else {
                labels.push(values)
            }
        })

        return labels.filter(Boolean)
    },

    clearFilters(keys = []) {
        keys.forEach((key) => delete this.activeFilters[key])

        this.$nextTick(() => this.updateResults())
    },

    loadMore() {
        this.updateResults(this.pagination.currentPage + 1)
    },
})
